/*
 Code commun à plusieurs interfaces permettant la gestion de certaines fonctionnalités au niveau des sous-blocs tel que l'ajout automatique d'une
 nouvelle ligne.
 */

var NOM_MODULE = 'gestion-roles';
var CLASSE_VALEUR_MODIFIEE = 'valeur-modifiee'; // la valeur du contrôle est modifié : sert à la sauvegarde du bloc/sous-bloc
var CLASSE_CONTROLE_SUPPRESSION = 'ctrl-suppression'; // le checkbox utilisé pour la suppression dans la section multiple
var CLASSE_CONTROLE_CHECKBOX = 'ctrl-checkbox'; // le checkbox personnalisé pour afficher un booléen
var CLASSE_NOUVELLE_LIGNE = 'nouvelle-ligne'; // une nouvelle ligne est créé : sert à ajouter des données
var CLASSE_SUPPRESSION_LIGNE = 'suppression-ligne'; // la ligne est en suppression : sert à supprimer dans la table à la sauvegarde
var CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE = 'suppression-ligne-sauvegardee'; // la ligne en suppression est sauvegardée : sert à indiquer que la ligne est supprimée dans la bd
var CLASSE_VALEUR_SAUVEGARDEE = 'sauvegarde'; // la valeur du contrôle est sauvegardée
var CLASSE_PORTRAIT_ANTERIEUR = 'portrait_anterieur'; // le portrait antérieur existe et sa valeur est différente de la valeur de l'évènement courant

var LIGNE_STATUT = Object.freeze({"none": 0, "insert": 1, "update": 2, "delete": 3});

function init_change_event_sous_bloc(container) {
    var selecteur;
    if (typeof(container) == 'undefined') {
        selecteur = $(':input.form-control');
    }
    else {
        selecteur = container.find(':input.form-control');
    }

    selecteur.on('change', function (event, data) {
        if (initializing_date_picker) { // DM: sinon ça fait une méchante boucle infinie quand on ajoute une nouvelle ligne, car l'initialisation du datepicker trigger automatiquement un on change
            return;
        }

        var ctrl = $(this);
        var ctrlDansSuppressionLigne = controleDansSuppressionLigne(ctrl);
        var ctrlSupprimerTout = ctrl.attr('id') == 'ctrl-suppression-tous';

        // si ce n'est pas le bloc b92_valeur_methode_revenu, on passe dans le return. Sinon, on notifie le changement
        // sur le contrôle
        if (ctrl.is('input.money') && ctrl.val() == '' &&
            !ctrl.closest('#b92-valeur-methode-revenu.blocForm').length) {
            return;
        }
        var ctrlIcone;
        if (ctrlSupprimerTout) {
            ctrlIcone = $(ctrl).parent().find('i');
            if (ctrl.is(':checked')) {
                ctrlIcone.removeClass('tout-desactive').addClass('tout-active');
            }
            else {
                ctrlIcone.removeClass('tout-active').addClass('tout-desactive');
            }
        }
        else if (ctrlDansSuppressionLigne) {

            // On vérifie si la case est cochée sur une ligne de section multiple et on indique la suppression éventuelle avec une barre horizontale sur la ligne
            var ctrlRow = ctrl.closest('.sous-bloc-form');
            var ctrlIsChecked = ctrl.is(':checked');

            // on toggle sur la classe de suppression de ligne
            var listeDiv = getDivSuppression(ctrlRow);
            listeDiv.toggleClass(CLASSE_SUPPRESSION_LIGNE, ctrlIsChecked);

            var idModelInstance = ctrlRow.attr('id-model-instance');
            // ajouter un attribut pour garder l'ancienne instance au cas où la ligne est réactivée
            if (ctrlIsChecked && idModelInstance != 'None' && ctrlRow.attr('bloc-editable') == 'False') {
                ctrlRow.attr('ancien-id-model-instance', idModelInstance);
            }

            // pour pouvoir réutiliser une ligne supprimée et sauvegardée dans la bd:
            // - on enlève la classe de suppression de ligne sauvegardée
            // - on ajoute la classe de modification sur au moins un contrôle de la ligne pour pouvoir sauvegarder la ligne sans aucune modification de la part de l'utilisateur
            if (listeDiv.hasClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE) && idModelInstance == 'None') {
                listeDiv.removeClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE);
                var inputFile = ctrlRow.find('input:file');
                if (inputFile.length > 0) {
                    ctrlRow.find('[name$="description"]').addClass(CLASSE_VALEUR_MODIFIEE);
                }
                else {
                    ctrlRow.find(':input:not(button)').first().addClass(CLASSE_VALEUR_MODIFIEE);
                }

                // si un ancien id-model-instance existe, alors le remettre dans id-model-instance et changer
                // bloc-editable à False comme avant
                var ancienneIdModelInstance = ctrlRow.attr('ancien-id-model-instance');
                if (ancienneIdModelInstance != undefined) {
                    ctrlRow.attr('id-model-instance', ancienneIdModelInstance);
                    ctrlRow.attr('bloc-editable', 'False');
                    ctrlRow.attr('reactiver-ligne', '');
                }
            }

            ctrlIcone = $(ctrl).parent().find('i');
            if (ctrl.is(':checked')) {
                ctrlIcone.removeClass('fa-square-o').addClass('fa-trash-o');
            }
            else {
                ctrlIcone.removeClass('fa-trash-o').addClass('fa-square-o');
            }

            // on toggle sur le disabled des contrôles de la ligne pour ne pas pouvoir modifier les valeurs tant que la ligne est cochée
            listeDiv.find(':input:not(.input-disabled), label.for-ctrl-checkbox').attr('disabled', function (index, valeur) {
                return !valeur;
            });

            // on toggle sur la méthode : utiliser dans le wizard, étape 1: documents
            ctrlRow.attr('methode', function (index, valeur) {
                if (valeur == 'PATCH' || valeur == 'POST') {
                    return 'DELETE';
                }
                return ctrlRow.attr('id-model-instance') == 'None' ? 'POST' : 'PATCH';
            });

            // pour les 2 sous-blocs se rattachant à la mutation de l'étape 1, si une valeur change, le prix rajusté sera recalculé
            if (ctrl.closest('#bien-non-immobilier-mutation, #rajustement-mutation').length) {
                calculerPrixVenteRajuste();
            }

            if (ctrl.closest('#b81-espace-locatif-residentiel').length) {
                updateTotaux81();
            }

            if (ctrl.closest('#b81-espace-locatif-nonresidentiel').length) {
                updateTotaux81();
            }

            var containerLignes = ctrl.closest('.bloc-container').find('.champs-multiple .sous-bloc-form .input-select-multiple').closest('.champs-multiple');
            cacherReperesSurSuppression(containerLignes);

            if ($(ctrl).closest('#b79-attestation-sous-bloc').length){
                ajouterEditerLigneImputerTemps(ctrl);
                retirerLigneImputerTemps(ctrl);
                $(ctrl).data('initial-value', $(ctrl).val());
            }
        }
        else {
            appliquerChangement(ctrl);

            //On vérifie si le changement de la valeur du contrôle est dans une nouvelle ligne d'une section multiple et on ajoute une nouvelle ligne sauf pour la case à cocher de suppression
            if (ctrl.is('.champs-multiple .' + CLASSE_NOUVELLE_LIGNE + ' .form-control')) {
                if (ctrl.is('.champs-multiple .input-auto-number .form-control')) {
                    ajouterNouvelleLigneSectionMultipleAutoNumber(ctrl);
                } else {
                    var champsMultiple = ctrl.closest('.champs-multiple');
                    var idChampsMultiple = champsMultiple.attr('id');

                    ajouterNouvelleLigneSectionMultiple(ctrl);

                    // on ajoute un slim scroll sur une section multiple
                    if (typeof ajouterSlimScrollEF !== 'undefined') {
                        if (idChampsMultiple == 'b08-agrandissement') {
                            ajouterSlimScrollEF($('#b08-agrandissement'), 150, true);
                            $('#b08-agrandissement').attr('hauteur-originale', 400);
                        }
                        if (idChampsMultiple == 'b81-espace-locatif-residentiel') {
                            ajouterSlimScrollEF($('#b81-espace-locatif-residentiel'), 505, true);
                            $('#b81-espace-locatif-residentiel').attr('hauteur-originale', 400);
                        }
                        if (idChampsMultiple == 'b81-espace-locatif-nonresidentiel') {
                            ajouterSlimScrollEF($('#b81-espace-locatif-nonresidentiel'), 505, true);
                            $('#b81-espace-locatif-nonresidentiel').attr('hauteur-originale', 400);
                        }
                        if (idChampsMultiple.startsWith('b05-document')) {
                            ajouterSlimScrollEF($('[id^="b05-document"]'), 400, true);
                            $('[id^="b05-document"]').attr('hauteur-originale', 400);
                            if($('#mode-read-only').val() === 'False') {
                                rendreChampMultipleOrdonnable($('[id^="b05-document"]'), "#form-ordre");
                            }
                        }
                        if (idChampsMultiple == 'b90-document') {
                            ajouterSlimScrollEF($('#b90-document'), 400, true);
                            $('#b90-document').attr('hauteur-originale', 400);
                        }

                        var estSlimScrollDiv = champsMultiple.parent().hasClass('slimScrollDiv');
                        if (estSlimScrollDiv) {
                            // on remet le focus sur le contrôle car le focus est rendu sur le scroll et on ne peut pas continuer de saisir le champ
                            if (!ctrl.hasClass('dateinput')) {
                                ctrl.focus();
                            }
                        }
                    }

                    /* code spécifique au bloc05 - ordonnancement des sous-bloc lors de l'ajout d'une nouvelle ligne */
                    if (idChampsMultiple.startsWith('b05-document')) {
                        var premierElement = champsMultiple.find('.sous-bloc-form').first();
                        var sousBlocCourant = $(ctrl).closest('.sous-bloc-form');
                        var ancienneNouvelleLigneB05 = champsMultiple.find('.nouvelle-ligne-b05');
                        if($(ancienneNouvelleLigneB05).length) {
                            sousBlocCourant.detach().insertAfter(ancienneNouvelleLigneB05);
                            $(ancienneNouvelleLigneB05).removeClass('nouvelle-ligne-b05');
                        } else if(premierElement.find('#form-bool_principale').is(":checked")) {
                            sousBlocCourant.detach().insertAfter(premierElement);
                        } else if(sousBlocCourant.find("[name='document.nom']").val() !== premierElement.find("[name='document.nom']").val()) {
                            sousBlocCourant.detach().insertBefore(premierElement);
                        }
                        sousBlocCourant.addClass('nouvelle-ligne-b05');

                        reordonnerChampsMultiples(champsMultiple, "#form-ordre");
                    }
                }
            }
            if ($(ctrl).closest('#b79-attestation-sous-bloc').length){
                ajouterEditerLigneImputerTemps(ctrl);
                synchroniserImputerTempsAttestations();
                $(ctrl).data('initial-value', $(ctrl).val());
            }

            if ($(ctrl).closest('#b04-terrain-general').length || $(ctrl).closest('#b04-terrain-agricole-boise').length)  {
                let inputAvantSuperficieExploitableNonExploitee;
                const typeTerrain = $(ctrl).closest('#b04-terrain-general').length ? 'b04-terrain-general' : 'b04-terrain-agricole-boise';

                if ($('#wizard').length > 0) {
                    /* On trouve le container d'avant (puisqu'ils ont les deux le même id, on retourne le premier trouvé
                    dans la page, qui est celui avant) */
                    inputAvantSuperficieExploitableNonExploitee = $('.step-pane.active').find("#" + typeTerrain).find('input#form-superficie_agricole_exploitable_non_exploitee');
                }

                gererTexteQuestionOmiseInscriteTerrain(ctrl, inputAvantSuperficieExploitableNonExploitee, typeTerrain);
                gererAffichageQuestionOmiseInscriteTerrain(ctrl, inputAvantSuperficieExploitableNonExploitee, typeTerrain);
            }

            var valueFalse;
            if (typeof CLASSE_CONTROLE_CHECKBOX !== 'undefined') {
                if (ctrl.is('.form-control.' + CLASSE_CONTROLE_CHECKBOX)) {
                    // on toggle sur la classe qui affiche le crochet ou le carré vide
                    ctrlIcone = ctrl.parent().find('i');
                    if (ctrl.is(':checked')) {
                        ctrlIcone.removeClass('fa-square-o').addClass('fa-check-square-o');
                    }
                    else {
                        ctrlIcone.removeClass('fa-check-square-o').addClass('fa-square-o');
                    }
                    // on met le checked/unchecked dans l'attribut 'value'
                    valueFalse = ctrl.attr('value_false');
                    ctrl.val(ctrl.is(':checked') ? 1 : valueFalse != undefined ? valueFalse : 0);
                }
            }

            // Lorsqu'on sélectionne une photo principale, on vide toutes les autres pour s'assurer d'en avoir toujours seulement une
            if (ctrl.attr('name') == 'bool_principale' && ctrl.is(':checked')) {
                // On sélectionne tous les checkbox du bloc autre que celui sélectionné
                var checkboxes = ctrl.closest('.champs-multiple').find('input[name="bool_principale"]:checked:enabled').not(ctrl);
                checkboxes.prop('checked', false);
                // On flag les checkboxes ayant été modifié pour qu'ils soient sauvegardé
                if (typeof appliquerChangement !== 'undefined')appliquerChangement(checkboxes);
                // on force la classe qui affiche le carré vide
                ctrlIcone = checkboxes.parent().find('i');
                ctrlIcone.removeClass('fa-check-square-o').addClass('fa-square-o');
                // on met le unchecked dans l'attribut 'value'
                valueFalse = ctrl.attr('value_false');
                checkboxes.val(valueFalse != undefined ? valueFalse : 0);
            }

            // chercher la remarque associée dans la fenêtre des remarques et lui assigner la valeur de la remarque saisie
            // si l'évènement vient de la fenêtre Remarques, éviter de réécrire une 2e fois
            if (ctrl.is('[name="remarque"]') && data != 'eventRemarques') {
                var idBloc = $(this).closest('.blocForm').attr('id_bloc');
                $('#remarques').find('.champs-multiple[id-bloc="' + idBloc + '"][id="remarque"] .sous-bloc-form textarea[name="remarque"]').val($(this).val());
            }

            if (ctrl.is('.ace-input-file')) {
                var typeDocumentOptions = $(this).closest('.sous-bloc-form').find('[name="typeDocument"] option:not([value=""])');
                if (typeDocumentOptions.length == 1) {
                    typeDocumentOptions.prop('selected', true);
                }
            }

            // mettre les repères modifiés si une donnée change sur une ligne ayant un qc
            if (ctrl.closest('.sous-bloc-form').find('.qc').length) {
                var sousBloc = ctrl.closest('.sous-bloc-form');
                var qcComposante = sousBloc.find('.qc [name$="composante"]');
                if (qcComposante != undefined && qcComposante.length) {

                    var noLigne = sousBloc.attr('no-ligne');
                    var reperesContainer = getReperesContainer(qcComposante);
                    var accordionComposante = reperesContainer.find('[name="accordion-qc-composante-' + qcComposante.val() + '"][no-ligne="' + noLigne + '"]');
                    var reperes = accordionComposante.find('.cell-repere.selected');
                    if (reperes.length) {
                        accordionComposante.find('.sous-bloc-form').addClass('repere-modifie');
                    }
                }
            }
        }
    });

}

function controleDansSuppressionLigne(ctrl) {

    return ctrl.is('.champs-multiple input:checkbox.form-control.' + CLASSE_CONTROLE_SUPPRESSION);
}

function ajouterNouvelleLigneSectionMultiple(controle, chercherNouvelleLigne, ajouterApres) {

    chercherNouvelleLigne = typeof chercherNouvelleLigne !== 'undefined' ? chercherNouvelleLigne : true;
    ajouterApres = typeof ajouterApres !== 'undefined' ? ajouterApres : true;
    var ligneCourante = $(controle).closest('.' + CLASSE_NOUVELLE_LIGNE);
    if (!chercherNouvelleLigne) {
        ligneCourante = $(controle).closest('.sous-bloc-form');
    }

    var champsMultiple = ligneCourante.closest('.champs-multiple');
    var nbLigneMax = champsMultiple.attr('nb-ligne-max');
    if (nbLigneMax !== undefined) {
        var nbLigne = champsMultiple.find('.sous-bloc-form').length;
        if (nbLigne == parseInt(nbLigneMax)) {
            disableControleSuppression(ligneCourante, false);
            if (chercherNouvelleLigne) {
                $(ligneCourante).removeClass(CLASSE_NOUVELLE_LIGNE);
            }
            // rendre l'image visible pour la ligne originale qui n'est maintenant plus vide
            $(ligneCourante).find('ul.ace-thumbnails > li').css('visibility', '');

            return;
        }
    }

    /* doit être appellé avant la destruction du select */
    var reouvrirSelectMultiple = controle.hasClass("geo-select") && controle.data('stay-open');
    var selecteurSelectMultiple = reouvrirSelectMultiple ? $(ligneCourante).find(`.geo-select[name='${controle.attr('name')}']`) : '';

    // DM: nettoyer/réinitialiser les select2
    var ctrlSelect2 = $(ligneCourante).find('.select2-container.geo-select, .fiche-select2-ajax, .select2-custom, .select2-ajax');
    if (ctrlSelect2.length > 0) {
        ctrlSelect2.select2("destroy");
    }

    if ($(ligneCourante).closest('#b81-espace-locatif-nonresidentiel').length > 0) {
        var inputAutocomplete = $('#b81-espace-locatif-nonresidentiel').find('[name="proprietaire"]');
        inputAutocomplete.each(function () {
            try {
                $(this).autocomplete("destroy");
            }
            catch (e) {
            }
        });
    }

    $.each(ligneCourante.find('.dateinput, .datepicker, .date-picker, .input-group.date'), function (){
        if($(this).data('daterangepicker')){
            $(this).data('daterangepicker').remove();
        }
        $(this).unmask();
    });
    ligneCourante.find('.dateinput, .datepicker, .date-picker, .input-group.date').removeData('daterangepicker');
    var nouvelleLigne = $(ligneCourante).clone(true);
    $(nouvelleLigne).find('.form-control').prop('checked', false);
    $(nouvelleLigne).find('.cboxElement').attr("href", "");
    $(nouvelleLigne).find('.cboxElement').removeClass("cboxElement").addClass("cboxElementVide");
    // On vérifie si la nouvelle ligne créée est utilisable par une caméra. Comme, dans ce cas, on doit utiliser document.getElementId parce que le sélecteur jquery est en readOnly et parce qu'on doit insérer un blob dans le  input file, on doit utiliser un id unique pour chaque nouvelle ligne.
    if ($(nouvelleLigne).find(':input[type="file"].form-control').attr('capture')) {
        $(nouvelleLigne).find(':input[type="file"].form-control').attr('id', 'form-nom-' + Date.now());
    }
    masquesSelection.init(ligneCourante);
    masquesSelection.init(nouvelleLigne);

    var ctrlInput = $(nouvelleLigne).find(':input.form-control').not('input[type=hidden].form-control');
    ctrlInput.val('').prop('defaultValue', '');
    ctrlInput.not('.input-disabled, .select-disabled, .date-disabled, [name$="qualiteComplexite"]').attr('disabled', false);
    ctrlInput.attr('title', '');
    if (typeof effacerChangement !== 'undefined') effacerChangement(ctrlInput);
    disableControleSuppression(nouvelleLigne, chercherNouvelleLigne);
    $(nouvelleLigne).find('div').removeClass(CLASSE_SUPPRESSION_LIGNE).removeClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE);
    // remettre la valeur du bloc-editable à True pour une nouvelle ligne
    $(nouvelleLigne).attr('bloc-editable', 'True');
    // remettre la valeur du id-model-instance à vide pour une nouvelle ligne
    $(nouvelleLigne).attr('id-model-instance', 'None');

    $(nouvelleLigne).attr('modifie', 'False'); // Seulement pour sous-bloc en dehors de l'éditeur de fiches
    // si l'élément à cloner contient un accordeon, on veut changer l'ID pour qu'il soit unique
    if($(nouvelleLigne).hasClass("sous-bloc-form-w-accordion")) {
        var nouvelleLigneCollapse = $(nouvelleLigne).find(".accordion-custom-collapse");
        $(nouvelleLigneCollapse).removeAttr("id");
        $(nouvelleLigneCollapse).uniqueId();
        $(nouvelleLigne).find(".accordion-custom-link").attr('data-accordion-link', $(nouvelleLigneCollapse).attr('id'));
    }
    erreursAjax.effacerErreurChamps($(nouvelleLigne));

    // exception pour b79 : remettre les valeurs par défaut pour typeEvenement et date_attestation
    if ($(ligneCourante).is('#b79-attestation-sous-bloc .sous-bloc-form')) {
        ctrlInput.filter('[name="typeEvenement"]').val(ligneCourante.find('input[name="typeEvenement"]').val());
        ctrlInput.filter('[name="date_attestation"]').val(moment().format('YYYY-MM-DD'));
        ctrlInput.filter('[name="signature"]').val();
        var btnSignatureB79 = ctrlInput.filter('[name="signature"]').siblings(".btn-signature");
        btnSignatureB79.addClass("aucune-signature-sauvegardee");
        btnSignatureB79.removeClass("btn-signature-rempli");
        btnSignatureB79.attr("disabled", false);
        btnSignatureB79.tooltip('destroy');
        btnSignatureB79.children(".badge-container").html('<span class="badge bg-red">À faire</span>');
        var user = ctrlInput.filter('[name="user"]');
        user.val(user.attr('id-user-assigne'));
    }
    if ($(ligneCourante).closest('#b79-remarque').length) {
        var dateCourante79= ligneCourante.find('.dateinput').val();
        var userCourante79= ligneCourante.find('[name="utilisateur"]').val();
        nouvelleLigne.find('.dateinput').val(dateCourante79).prop('disabled', true);
        nouvelleLigne.find('[name="utilisateur"]').val(userCourante79).prop('disabled', true);
    }

    function initvoiepubliqueb81ajout(ligne, sous_bloc) {
        if ($(ligne).is('#'+sous_bloc+' .row.sous-bloc-form.nouvelle-ligne')) {
            var b81nr = $('#'+sous_bloc+' .row.sous-bloc-form.nouvelle-ligne');
            if (b81nr.find('select[name="voiePublique"] option').length == 2) {
                var ctrlInput1 = $(nouvelleLigne).find(':input.form-control').not('input[type=hidden].form-control');
                var vpinput = ctrlInput1.filter('[name="voiePublique"]');
                var vp = ligneCourante.find('[name="voiePublique"]').val();
                vpinput.val(vp);
                $('#'+sous_bloc+'  .row.sous-bloc-form.nouvelle-ligne').find('[name="voiePublique"] option:last').attr('selected', 'selected');
                //vpinput.attr('disabled', true);
            }
        }
    }
    initvoiepubliqueb81ajout(ligneCourante, 'b81-espace-locatif-nonresidentiel');
    initvoiepubliqueb81ajout(ligneCourante, 'b81-espace-locatif-residentiel');
    // pour les inputs +/-, il faut enlever leur data et les réinitialiser
    if (typeof resetIntegerSpinner == 'function') resetIntegerSpinner(nouvelleLigne); // Note: cette fonction existe seulement dans l'éditeur de fiche et non utile dans les sous-bloc ailleur

    var sousContainer = $(ligneCourante).next(); // geo-form
    if (!sousContainer.hasClass('sous-container')) {
        sousContainer = $();
    }

    if (ajouterApres) {
        if (sousContainer.length) { // geo-form
            sousContainer.after(nouvelleLigne);
            dupliquerNouveauSousContainer(sousContainer);
        }
        else {
            $(ligneCourante).after(nouvelleLigne);
        }
    }
    else {
        $(ligneCourante).before(nouvelleLigne);
    }
    disableControleSuppression(ligneCourante, false);
    if (chercherNouvelleLigne) {
        $(ligneCourante).removeClass(CLASSE_NOUVELLE_LIGNE);
    }

    // on met un no de ligne pour la nouvelle ligne
    $(nouvelleLigne).attr('no-ligne', $(nouvelleLigne).closest('.champs-multiple').find('.sous-bloc-form').index($(nouvelleLigne)) + 1);

    // On nettoie et réinitialise les input files suite à la copie de ligne
    var ctrlFile = $(nouvelleLigne).find('input:file').first();
    if (ctrlFile.length > 0) {
        ctrlFile.removeData('ace_file_input');
        ctrlFile.closest('div').append(ctrlFile).find('label').remove();

        var organisation;
        var organisationInput = $("#organisationJSON");
        if(organisationInput.length && organisationInput.val() !== '') {
            organisation = JSON.parse(organisationInput.val());
        } else {
            organisation = securite.reqOrganisation();
        }
        initAceInputFile(ctrlFile, organisation);
    }

    initSelect2($(ligneCourante));
    if(reouvrirSelectMultiple) {
        $(selecteurSelectMultiple).select2('open');
    }
    initSelect2($(nouvelleLigne));

    // initialiser les select2 avec ajax de la ligne courante et de la nouvelle ligne
    if ($(ligneCourante).find('.fiche-select2-ajax').length > 0) {
        initCodeUtilisationSelect2($(ligneCourante));
        initCodeUtilisationSelect2($(nouvelleLigne));

        initProprietaireSelect2($(ligneCourante));
        initProprietaireSelect2($(nouvelleLigne));

        // enlever le tooltip sur la nouvelle ligne
        $(nouvelleLigne).find('.fiche-select2-ajax').attr('title', '');
    }


    // enlever le data associé au datepicker et le réinitialiser pour éviter qu'il reste avec le data de la ligne dont il est copié
    $.each(nouvelleLigne.find('.dateinput, .datepicker, .date-picker, .input-group.date'), function (){
        if($(this).data('daterangepicker')){
            $(this).data('daterangepicker').remove();
        }
    });
    nouvelleLigne.find('.dateinput, .datepicker, .date-picker, .input-group.date').removeData('daterangepicker');
    init_date_picker(nouvelleLigne);
    init_date_picker(ligneCourante);

    // on nettoie et on réinitialise le data et les évènements sur les inputs money
    nouvelleLigne.find('input.money').autoNumeric('destroy');
    formaterMonnaie(nouvelleLigne.find('input.money'), 0);

    // s'assurer de ne pas copier l'icône X du checkbox de suppression
    nouvelleLigne.find('.ctrl-suppression').next('i').removeClass('fa-trash-o fa-square-o').addClass('fa-square-o');

    // rendre l'image visible pour la ligne originale qui n'est maintenant plus vide
    $(ligneCourante).find('ul.ace-thumbnails > li').css('visibility', '');

    initCascade($(nouvelleLigne)); // resetter les enfants des combobox cascade sinon ça va cascader sur l'ancienne ligne

    // valeur par défaut spécifique
    var formCommunication = $(ligneCourante).closest('#form_communication');
    if (formCommunication.length > 0) {
        var inputEmploye = $(ligneCourante).find('[name=userRepondant]');
        if (!inputEmploye.val()) {
            var userIdConnecte = formCommunication.find('[name=user-id-connecte]').val();
            inputEmploye.select2('val', userIdConnecte);
        }
    }

    var newLineCreated = $(ligneCourante).data('newLineCreated');
    if (newLineCreated) {
        $(nouvelleLigne).data('newLineCreated', newLineCreated);
        newLineCreated($(ligneCourante), $(nouvelleLigne));
    }

    return $(nouvelleLigne);
}

function copierLigneExistanteSectionMultiple(controleTrouve, controleDerniereLigne, chercherNouvelleLigne, ajouterApres) {

    chercherNouvelleLigne = typeof chercherNouvelleLigne !== 'undefined' ? chercherNouvelleLigne : true;
    ajouterApres = typeof ajouterApres !== 'undefined' ? ajouterApres : true;

    var ligneCopie = controleTrouve.closest('.sous-bloc-form');
    var ligneCourante = !chercherNouvelleLigne ? $(controleDerniereLigne).closest('.sous-bloc-form') : $(controleDerniereLigne).closest('.' + CLASSE_NOUVELLE_LIGNE);

    var nouvelleLigne = $(ligneCopie).clone(true);
    $(nouvelleLigne).find('div').removeClass(CLASSE_SUPPRESSION_LIGNE).removeClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE);

    // pour les inputs +/-, il faut enlever leur data et les réinitialiser
    resetIntegerSpinner(nouvelleLigne);

    if (ajouterApres) {
        $(ligneCourante).after(nouvelleLigne);
    }
    else {
        $(ligneCourante).before(nouvelleLigne);
    }
    disableControleSuppression(ligneCourante, false);
    if (chercherNouvelleLigne) {
        $(ligneCourante).removeClass(CLASSE_NOUVELLE_LIGNE);
    }

    return $(nouvelleLigne);
}

function ajouterNouvelleLigneSectionMultipleAutoNumber(ctrl) {
    var min = $(ctrl).closest('.champs-multiple').attr("data-min");
    var max = $(ctrl).closest('.champs-multiple').attr("data-max");

    var input_number = $('.input-label-style').length;
    var ligneCourante;
    if (input_number < max - min + 1) {
        ajouterNouvelleLigneSectionMultiple(ctrl);
    } else {
        ligneCourante = $(ctrl).closest('.sous-bloc-form');
        $(ligneCourante).removeClass(CLASSE_NOUVELLE_LIGNE);
        $(ligneCourante).find('input.ctrl-suppression').attr('disabled', false);
        $(ligneCourante).find('.for-ctrl-suppression').attr('disabled', false);
    }

    ligneCourante = $(ctrl).closest('.sous-bloc-form');
    var ctrlInput = $(ligneCourante).find('input.input-label-style');

    //create liste from sous bloc autre avec input-auto-number
    var allLine = $(ctrl).closest('.champs-multiple');
    var my_array = [];
    $(allLine).children('.sous-bloc-form').each(function () {
        if ($(this).find('input.input-label-style').val() != '') {
            my_array.push(Number($(this).find('input.input-label-style').val()));
        }
    });

    //insere le plus petit nombre pas dans la liste
    for (var i = Number(min); i < Number(max) + 1; i++) {
        if (!~jQuery.inArray(i, my_array)) break;
    }
    $(ctrlInput).val(i);

}

function disableControleSuppression(ligne, disabled) {

    $(ligne).find('input:checkbox.form-control.' + CLASSE_CONTROLE_SUPPRESSION).attr('disabled', disabled);
    $(ligne).find('label.for-ctrl-suppression').attr('disabled', disabled);
}

function getDivSuppression(ligne) {
    if (ligne.parents().hasClass('divTable-fake')) {
        return ligne.children('div').first().children('div')
            .filter(function () {
                return $(this).find(':input').not('input[type="hidden"]').length > 0; // le div doit avoir au moins un input sans qu'il soit hidden
            });
    } else {
        // si le contrôle de suppression n'est pas dans les premiers children div de la ligne, c'est qu'il y a qu'un seul div au début
        // alors, il faut trouver les inputs dans le dernier div sauf le div ayant le contrôle de suppression (ex: b81 - espaces locatifs non résidentiels)
        var divSuppressionInterne = ligne.find('input.ctrl-suppression').length == 1 && ligne.children('div').length == 1;
        var divSuppressionAvecCaroussel = ligne.hasClass('sous-bloc-form-w-accordion');

        var divs = ligne.children('div').not('.sortable-handle-logo').first().children('div').children('div');

        if(divSuppressionAvecCaroussel) {
            divs = ligne.find('.panel-body').find('.form-group');
        }
        else if (divSuppressionInterne) {
            var divLast = divs.last();
            divs = divs.not(divLast).add(divLast.children('div').not(':last'));
        }

        return divs
            .filter(function () {
                return $(this).find(':input').not('input[type="hidden"]').length > 0; // le div doit avoir au moins un input sans qu'il soit hidden
            });
    }
}

function getCtrlSuppressionException(ligne) {
    return ligne.find('input:hidden, label.for-ctrl-suppression, input.ctrl-suppression');
}

function appliquerChangement(controle) {
    // On vérifie si la "valeur" est différente de la "valeur de défaut" et on met une couleur de fond différente
    // On n'efface pas la couleur de fond si on a sauvegardé au moins une fois

    if (($('#wizard').length > 0 && controle.closest('.blocForm').length == 0) || controleEstModifie(controle)) {
        marquerChangement(controle);
    }
    else {
        effacerChangement(controle, true);
    }
}

function controleEstModifie(ctrl) {
    if(ctrl.data('typecustom')=='hiddencustom'){
        if(ctrl.data('defaut')!=ctrl.val()){
            return true;
        }
    }
    if(ctrl.is('ul')){
        var valeur_clique = ctrl.find('li.selected').attr('code');
        if (valeur_clique == undefined){
            valeur_clique = ctrl.find('li.selected').attr('value');
        }
        if(valeur_clique != ctrl.attr('selection-precedente')){
            return true;
        }
    }
    if (ctrl.is('select.chosen-select') || ctrl.is('.geo-select')) {
        var estModifie = false;

        if (ctrl.is('.geo-select-ajax')) {
            if (ctrl.val() != ctrl.attr('initial-value')) {
                estModifie = true;
            }
        }
        else {
            ctrl.find("> option").each(function () {
                if (this.defaultSelected != this.selected) {
                    estModifie = true;
                }
            });
        }

        return estModifie;
    }

    return (ctrl.is('input:checkbox') && !controleDansSuppressionLigne(ctrl) &&
        ctrl.is(':checked') != ctrl.prop('defaultChecked') &&
        !(ctrl.prop('defaultValue') === '' &&
        ctrl.val() === '0'))

        ||

        (ctrl.is('input:radio') && !controleDansSuppressionLigne(ctrl) &&
        ctrl.is(':checked') != ctrl.prop('defaultChecked'))

        ||

        (ctrl.is('input.integer-spinner') && !controleDansSuppressionLigne(ctrl) &&
        ctrl.val() !== ctrl.prop('defaultValue'))

        ||

        (ctrl.is('input') && !controleDansSuppressionLigne(ctrl) &&
        ctrl.val() !== ctrl.prop('defaultValue') &&
        ctrl.val() !== parseFloat(ctrl.prop('defaultValue')))

        ||

        (ctrl.is('textarea') && !controleDansSuppressionLigne(ctrl) &&
        ctrl.val() !== ctrl.prop('defaultValue') &&
        ctrl.val() !== parseFloat(ctrl.prop('defaultValue')))

        ||

        (!ctrl.is('.container-select-multiple-input-multiple select') &&
        (ctrl.is('.container-select-multiple select') || ctrl.is('select')) &&
        (!(ctrl.prop('selectedIndex') == -1 && ctrl.find('option[selected]').length == 0)) &&
        (ctrl.prop('selectedIndex') == -1 || !ctrl.prop('options')[ctrl.prop('selectedIndex')].defaultSelected))

        ||

        // sert dans le cas de l'importation des fichiers en lot car on ne peut pas assigner ctrl.val()
        (ctrl.is('input:file') && !controleDansSuppressionLigne(ctrl) &&
        ctrl.parent().find('.selected').length == 1);

}

function marquerChangement(controle, afficherPortraitAnterieur) {
    // ne pas marquer le changement sur les contrôles ayant la classe 'exception-save'
    controle = controle.not('.exception-save');
    if (controle.length) {

        afficherPortraitAnterieur = typeof afficherPortraitAnterieur !== 'undefined' ? afficherPortraitAnterieur : false;

        if (!afficherPortraitAnterieur) {
            controle.addClass(CLASSE_VALEUR_MODIFIEE);
        }


        // si on trouve un input sur un select, c'est le input qui aura la couleur de fond
        var ctrlInput = getInputSelectSimple(controle);
        if (ctrlInput != null) {
            controle = ctrlInput;
        }
        selectGrisInputChoisi();
        controle.addClass(CLASSE_CONTROLE_MODIFIE);
        // appliquer le changement sur l'icone du checkbox en plus du checkbox lui-même
        if (controle.is('.' + CLASSE_CONTROLE_CHECKBOX)) {
            controle.parent().find('i').addClass(CLASSE_CONTROLE_MODIFIE);
        }
    }
}

function effacerChangement(controle, verifierSauvegarde) {

    verifierSauvegarde = typeof verifierSauvegarde !== 'undefined' ? verifierSauvegarde : false;

    var estSauvegarde = false;
    if (verifierSauvegarde) {
        if (controle.is('.form-control.' + CLASSE_VALEUR_SAUVEGARDEE)) {
            estSauvegarde = true;
        }
    }

    controle.removeClass(CLASSE_VALEUR_MODIFIEE);

    if (controle.is('input:radio')) {
        // dans un groupe de boutons radio, il faut gérer les autres radios qui ne sont pas cliqués
        $.each(controle.closest('.form-group').find('input:radio').not(controle), function () {
             $(this).removeClass(CLASSE_VALEUR_MODIFIEE);
        });
    }

    if (typeof getInputSelectSimple !== 'undefined') {
        // si on trouve un input sur un select, c'est le input à qui on efface la couleur de fond si ce n'est pas sauvegardé
        var ctrlInput = getInputSelectSimple(controle);
        if (ctrlInput != null) {
            controle = ctrlInput;
        }
    }

    if (typeof CLASSE_CONTROLE_MODIFIE !== 'undefined') {
        if (!estSauvegarde && !controle.hasClass(CLASSE_PORTRAIT_ANTERIEUR)) {
            controle.removeClass(CLASSE_CONTROLE_MODIFIE);
            if (controle.is('.' + CLASSE_CONTROLE_CHECKBOX)) {
                controle.parent().find('i').removeClass(CLASSE_CONTROLE_MODIFIE);
            }
        }
    }
}

function sousBlocEstModifie(sousBloc) {
    if (sousBloc.hasClass('repere')) {
        return sousBloc.hasClass('repere-modifie');
    }

    // On vérifie si une donnée a changé ou si on veut supprimer une ligne dans le sous-bloc
    return sousBloc.find('.form-control.' + CLASSE_VALEUR_MODIFIEE).length != 0 ||
        (sousBloc.find('.' + CLASSE_SUPPRESSION_LIGNE).length != 0);
}

// Actions pour la sauvegarde d'un sous-bloc:
// si la ligne n'est pas editable
//  - ajout         : impossible car la ligne n'est pas éditable donc la ligne existe forcément
//  - modification  : changer la date de fin du registre actuel et insérer un nouveau registre
//  - suppression   : changer la date de fin du registre actuel (donc, rien à supprimer)
//
// si la ligne est editable
//  - ajout         : insérer un nouveau registre
//  - modification  : modifier le registre actuel
//  - suppression   : supprimer le registre actuel
function ajaxSauvegarderSousBloc(ligne, params, async, ligneStatut, nomBloc, idBatiment, dateEvenement, idFormulaire, sequence, paramsOptionnels, callback, callbackError) {
    var paramsPreSauvegarde = preSauvegardeSousBloc(ligne, params, ligneStatut, idBatiment, dateEvenement, idFormulaire);
    if (paramsPreSauvegarde != undefined) {
        var url = '/' + NOM_MODULE + '/' + nomBloc + '/';
        if (paramsPreSauvegarde.idModelInstance != 'None') {
            if (paramsPreSauvegarde.blocEditable == 'True') {
                url += paramsPreSauvegarde.idModelInstance + '/';
            }
            else if (paramsPreSauvegarde.type == 'DELETE') {
                var response = undefined;
                postSauvegardeSousBloc(paramsPreSauvegarde.type, nomBloc, ligne, dateEvenement, paramsPreSauvegarde.idModelInstance, response, sequence);
                return;
            }
        }

        var wizard_mode = false;
        for (var index_param in params) {
            if (params[index_param]['name'] == 'wizard_mode') {
                wizard_mode = true;
                break;
            }
        }

        // Cas lorsque la ligne contient un input file et qu'un fichier a été sélectionné
        var inputFile = ligne.find('input:file');
        if (inputFile.length > 0 && ligne.find('.selected').length > 0) {
            paramsOptionnels.push({'name': 'id_formulaire', 'value': idFormulaire});

            if (typeof sauvegarderDocument !== 'undefined') {
                sauvegarderDocument(ligne, idBatiment, dateEvenement, idFormulaire, url, paramsPreSauvegarde.type, paramsOptionnels,
                    function (data) {
                        postSauvegardeSousBloc(paramsPreSauvegarde.type, nomBloc, ligne, dateEvenement, paramsPreSauvegarde.idModelInstance, data.result, sequence);
                        if (typeof callback !== 'undefined') {
                            callback();
                        }
                    },
                    function (e, data) {
                        //Callback en cas d'erreurs;
                        if (typeof callbackError !== 'undefined') {
                            callbackError(data.jqXHR, data.textStatus, data.errorThrown);
                        }
                    });
            }

        } else {
            var headers = {}; // On fait d'abord un insert (POST)
            var typeRequete = paramsPreSauvegarde.type;
            if (paramsPreSauvegarde.type != 'POST') headers = {'X-HTTP-Method-Override': typeRequete};
            //var async = idFormulaire == -1 ? true : false;

            // On copie le registre courant: donc on insère un nouveau registre dans la bd de la ligne actuelle
            var jqxhr = $.ajax({
                headers: headers, // Voir http://www.django-rest-framework.org/topics/browser-enhancements
                type: typeRequete,
                url: url,
                data: params,
                dataType: 'json',
                async: async
            });
            jqxhr
                .done(function (response, textStatus, jqXHR) {
                    // si c'est un DELETE(status=204), changer la response pour lui passer le type ici, sera utile pour la méthode appelée par la suite
                    if (jqXHR.status == 204) {
                        response = paramsPreSauvegarde.type;
                    }
                    postSauvegardeSousBloc(paramsPreSauvegarde.type, nomBloc, ligne, dateEvenement, paramsPreSauvegarde.idModelInstance, response, sequence);
                    if (typeof callback !== 'undefined') {
                        callback();
                    }
                });
            jqxhr
                .fail(function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status == 400) {
                        if (!wizard_mode && idFormulaire != -1 && typeof traiterValidation !== 'undefined') {
                            var erreurs = $.parseJSON(jqXHR.responseText);
                            traiterValidation(ligne, jqXHR, errorThrown, erreurs, sequence);
                        }
                    }
                    if (typeof callbackError !== 'undefined') {
                        callbackError(jqXHR, textStatus, errorThrown);
                    }
                });
        }
    }
}

function preSauvegardeSousBloc(ligne, params, ligneStatut, idBatiment, dateEvenement, idFormulaire) {
    var idModelInstance = ligne.attr('id-model-instance');
    var blocEditable = ligne.attr('bloc-editable');
    var type = 'POST'; // Action par défaut

    // Action sur une nouvelle ligne (soit un insert ou delete)
    if (idModelInstance == 'None') {
        if (ligneStatut == LIGNE_STATUT.delete) {
            // On vide simplement la nouvelle ligne côté client car elle n'a jamais été sauvegardée
            return;
        }
        getParamsSuppPourInsertion(params, ligne, idBatiment, dateEvenement, idFormulaire);
    // Action sur une ligne existante
    } else {

        // La ligne existante a déjà été dupliquée donc elle est maintenant éditable sans restriction
        if (blocEditable == 'True') {
            // On devra éliminer la ligne sans problème car elle a déjà été dupliquée
            if (ligneStatut == LIGNE_STATUT.delete) {
                type = 'DELETE';
            }
            else {
                type = 'PATCH';
                getParamsSuppPourInsertion(params, ligne, idBatiment, dateEvenement, idFormulaire);
            }

        // Si la ligne n'est pas éditable...
        } else {
            if (ligneStatut == LIGNE_STATUT.delete) {
                // On vient simplement updater la date_fin du registre
                type = 'DELETE';
            }
            else if (forcerUpdateDocument(ligne)) {
                type = 'PATCH';
                getParamsSuppPourInsertion(params, ligne, idBatiment, dateEvenement, idFormulaire);
            }
            else {
                getParamsSuppPourInsertion(params, ligne, idBatiment, dateEvenement, idFormulaire);
            }
        }
    }

    return {'type': type, 'idModelInstance': idModelInstance, 'blocEditable': blocEditable};
}

function getParamsSuppPourInsertion(params, bloc, idBatiment, dateEvenement, idFormulaire) {
    if (modeSave == ModeSave.MENU) {
        return;
    }

    var sousBlocImbriques = [];
    if (typeof(idBatiment) !== 'undefined') { // Il est possible d'ajouter un sous-bloc à un type d'évènement sans avoir identifié l'ue (wizard)
        var composante = undefined;
        if (bloc.is('.champs-multiple .sous-bloc-form')) {
            var containerLigne = bloc.closest('.champs-multiple');
            var attrImbrique = containerLigne.attr('imbrique');
            if (attrImbrique != undefined) {
                sousBlocImbriques = attrImbrique.split(',');
                composante = containerLigne.attr('composante');
            }
        }
        switch (idFormulaire) {
            case -1:    // cas provenant du wizard
            case ID_FORMULAIRE.terrainGeneral:
            case ID_FORMULAIRE.terrainAgricoleBoise:
            case ID_FORMULAIRE.renseignementAdministratif:
                params.push({name: 'uniteEvaluation', value: idBatiment});
                $.each(sousBlocImbriques, function (index, sousBlocImbrique) {
                    params.push({name: sousBlocImbrique + '.uniteEvaluation', value: idBatiment});
                    if (composante != undefined) {
                        params.push({name: sousBlocImbrique + '.composante', value: composante});
                    }
                });
                break;
            default:
                params.push({name: 'batiment', value: idBatiment});
                $.each(sousBlocImbriques, function (index, sousBlocImbrique) {
                    params.push({name: sousBlocImbrique + '.batiment', value: idBatiment});
                    if (composante != undefined) {
                        params.push({name: sousBlocImbrique + '.composante', value: composante});
                    }
                });
                break;
        }
    }
    params.push({name: 'date_debut', value: dateEvenement});
    $.each(sousBlocImbriques, function (index, sousBlocImbrique) {
        params.push({name: sousBlocImbrique + '.date_debut', value: dateEvenement});
    });
}

function postSauvegardeSousBloc(type, nomBloc, ligne, dateEvenement, idModelInstance, response, sequence) {
    if (type == 'POST') {

        // On vient actualiser la date_fin du registre précédent
        if (idModelInstance != 'None') updateDateFinDernierRegistre(nomBloc, ligne, dateEvenement, idModelInstance);

        $.each(response, function (index, value) {
            // On récupère seulement le premier élément qui est l'id model instance
            idModelInstance = value;
            return false;
        });

        ligne.attr('bloc-editable', 'True');
        ligne.attr('id-model-instance', idModelInstance);

    } else if (type == 'DELETE') {
        // On vient actualiser la date_fin du registre précédent si on n'arrive pas de la réponse du call ajax du delete précédemment exécuté
        if (idModelInstance != 'None' && response == undefined) updateDateFinDernierRegistre(nomBloc, ligne, dateEvenement, idModelInstance);

        ligne.attr('id-model-instance', 'None');
        ligne.attr('bloc-editable', 'True');
        // FB: on va commenter cette ligne car on veut réutiliser la ligne qui a été supprimée
        //disableControleSuppression(ligne, true);
        // si la ligne est un repère, mettre la nouvelle valeur par défaut
        if (ligne.hasClass('repere')) {
            ligne.removeClass('repere-modifie');
            ligne.attr('id-repere-defaut', 'None');
            ligne.attr('id-sous-bloc-parent', 'None');
            ligne.closest('[id^=accordion-qc-composante]').attr('id-sous-bloc-parent', 'None');
            //ligne.addClass('repere-suppression-sauvegarde').removeClass('repere-suppression');
        }
        // remettre la response à undefined pour ne pas prendre ceci comme un avertissement qu'il faut afficher
        response = undefined;
    }

    // si la ligne est un repère, mettre la nouvelle valeur par défaut
    if (type != 'DELETE' && response.repere) {
        ligne.removeClass('repere-modifie');
        ligne.attr('id-repere-defaut', response.repere);
        // assigner le id-sous-bloc-parent au repère et à l'accordion
        var idSousBlocParent = response.b59Foyer ? response.b59Foyer : response.b63DependanceDetachee ? response.b63DependanceDetachee : 'None';
        if (idSousBlocParent != 'None') {
            ligne.attr('id-sous-bloc-parent', idSousBlocParent);
            ligne.closest('[id^=accordion-qc-composante]').attr('id-sous-bloc-parent', idSousBlocParent);
        }
    }

    // On affiche la photo principale sélectionnée
    if (type != 'DELETE') {
        afficherPhotoPrincipale(nomBloc, response);
    }

    if (typeof traiterAvertissement !== 'undefined') {
        if (response != undefined && response instanceof Object && 'warning' in response) {
            traiterAvertissement(ligne, response['warning'], sequence);
        }
    }
    if (typeof effacerValidation !== 'undefined') effacerValidation(ligne);
    resetControle(ligne);
}

function updateDateFinDernierRegistre(nomBloc, registre, dateEvenement, idModelInstance) {

    // mettre à jour la date de fin du registre précédent
    var urlUpdateDateFin = '/' + NOM_MODULE + '/' + nomBloc + '/' + idModelInstance + '/';
    var params = [];
    params.push({name: 'date_fin', value: dateEvenement});

    var attrImbrique = registre.closest('.champs-multiple').attr('imbrique');
    if (attrImbrique != undefined) {
        var sousBlocImbriques = attrImbrique.split(',');
        $.each(sousBlocImbriques, function (index, sousBlocImbrique) {
            params.push({name: sousBlocImbrique + '.date_fin', value: dateEvenement});
        });
    }

    $.ajax({
        headers: {'X-HTTP-Method-Override': 'PATCH'}, // Voir http://www.django-rest-framework.org/topics/browser-enhancements
        type: 'PATCH',
        url: urlUpdateDateFin,
        data: params,
        dataType: 'json',
        async: false,
        success: function (response) {
        },
        error: function (jqXHR, textStatus, errorThrown) {
        }
    });
}

function resetControle(bloc) {

    // on vient de sauvegarder avec succès :
    //      on assigne la valeur de défaut égale à la valeur du contrôle modifié
    //      on ajoute la classe de sauvegarde
    //      on enlève la classe de valeur modifiée

    var ctrls = bloc.find('.form-control.' + CLASSE_VALEUR_MODIFIEE);
    $.each(ctrls, function (index, valeur) {
        var ctrl = $(valeur);

        if (ctrl.is('input:checkbox')) {
            ctrl.prop('defaultChecked', ctrl.is(':checked'));
        }

        else if (ctrl.is('input:radio')) {
            // dans un groupe de boutons radio, il faut gérer le radio cliqué ainsi que les autres radios qui ne sont
            // pas cliqués
            $.each(ctrl.closest('.form-group').find('input:radio'), function() {
                $(this).prop('defaultChecked', $(this).is(':checked'));
            });
        }

        else if (ctrl.is('input')) {
            ctrl.prop('defaultValue', ctrl.val());
        }

        else if (!ctrl.is('.container-select-multiple-input-multiple select') &&
            (ctrl.is('.container-select-multiple select') || ctrl.is('select:not(.geo-select)'))) {
            $.each(ctrl.prop('options'), function (index, option) {
                $(option).prop('defaultSelected', false);
            });
            if (ctrl.prop('selectedIndex') != -1) {
                ctrl.prop('options')[ctrl.prop('selectedIndex')].defaultSelected = true;
            }

        }
    });

    ctrls.addClass(CLASSE_VALEUR_SAUVEGARDEE)
        .removeClass(CLASSE_VALEUR_MODIFIEE);

    // pour les suppressions de ligne
    var divsSuppression = bloc.find('div.' + CLASSE_SUPPRESSION_LIGNE);
    // changer la classe de suppression pour la classe de suppression sauvegardée car ça empêche de supprimer une ligne déjà supprimée
    divsSuppression.addClass(CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE)
        .removeClass(CLASSE_SUPPRESSION_LIGNE);

    if (bloc.hasAttr('reactiver-ligne')) {
        bloc.removeAttr('reactiver-ligne');
    }
    if (bloc.hasAttr('id-document-ne-pas-creer')) {
        bloc.removeAttr('id-document-ne-pas-creer');
    }
}

function getValidationSousBlocs(sousBlocsValidation, dateEvenement, exceptionsSauvegarde, exceptionsLigneSansDonnee, exceptionsLigne) {
    var validation = {};

    $.each(sousBlocsValidation, function (index, sousBloc) {
        var $sousBloc = $(sousBloc);
        var nomSousBloc = $sousBloc.attr('id');

        var blocDivision = getBlocDivision($sousBloc, modeSave);

        var valDivision = validation[blocDivision.nom_division];
        if (typeof(valDivision) == 'undefined')
            valDivision = validation[blocDivision.nom_division] = {
                info: blocDivision
            };

        var params = getParamsSousBloc($sousBloc, blocDivision, dateEvenement, exceptionsSauvegarde, exceptionsLigneSansDonnee, exceptionsLigne);

        // DM 2018-02-12: ajouté pour la sauvegarde de communication, devrait être générique tout de même, en espérant que ça ne fasse rien planter à côté
        params = masquesSelection.striper($sousBloc, params);

        // ajout d'un index pour chaque ligne de sous-bloc, en partant de zéro
        if (Object.keys(params).length > 0) {
            $.each(params, function (index, value) {
                valDivision[nomSousBloc + '_' + index] = value;
            });
        }
    });

    return validation;
}


function getParamsSousBloc(sousBloc, blocDivision, dateEvenement, exceptionsSauvegarde, exceptionsLigneSansDonnee, exceptionsLigne) {
    // exceptionSauvegarde : sert pour valider le bloc seulement, pas pour le sauvegarder(ex.: documents)
    // exceptionsLigneSansDonnee : sert pour valider les lignes qui ont un seul champ et qu'on veut vérifier qu'ils ne soient pas vides (ex.: QC)
    // exceptionsLigne : sert pour ne pas ni valider ni sauvegarder ces lignes (ex.: les lignes du portrait antérieur du bloc 79)

    var nomSousBloc = sousBloc.attr('id');
    var idBloc = sousBloc.closest('.blocForm').attr('id_bloc');
    var lignes = sousBloc.find('.sous-bloc-form').not('.sous-bloc-form.nouvelle-ligne').not(exceptionsLigne);
    var paramsSousBlocs = {};

    var estExceptionSauvegarde = false;
    $.each(exceptionsSauvegarde, function (index, exception) {
        if (sousBloc.is(exception)) {
            estExceptionSauvegarde = true;
            return false;
        }
    });
    var estExceptionLigneSansDonnee = false;
    $.each(exceptionsLigneSansDonnee, function (index, exception) {
        if (sousBloc.is(exception)) {
            estExceptionLigneSansDonnee = true;
            return false;
        }
    });

    // On itère sur chaque ligne du sous-bloc
    $.each(lignes, function (index, valeur) {
        var ligne = $(valeur);
        var sousBlocModifie = sousBlocEstModifie(ligne);
        var ligneSansDonnee = ligneEstSansDonnee(ligne);

        // on vérifie que la ligne n'est pas vide
        // mais il faut quand même valider les QC qui ont un seul champ et qu'on veut vérifier qu'ils ne soient pas vides
        if ((ligneSansDonnee && sousBlocModifie) || !ligneSansDonnee || estExceptionLigneSansDonnee) {
            var paramsLigne = getParamsLigneSousBloc(ligne, true);
            var params = paramsLigne.params;
            var ligneStatut = paramsLigne.ligneStatut;
            var erreurFichier = ligne.find('.ace-file-container.selected .ace-error').attr('erreur');

            if (params.length > 0) {
                // utilisé pour les sous-blocs avec bâtiments différents pour chaque ligne, comme dans correction mineure
                var idBatimentLigne = ligne.attr('id-batiment');
                if (!idBatimentLigne) {
                    idBatimentLigne = blocDivision.id_batiment;
                }

                var paramsPreSauvegarde = preSauvegardeSousBloc(ligne, params, ligneStatut, idBatimentLigne, dateEvenement, blocDivision.id_formulaire);
                if (paramsPreSauvegarde != undefined) {
                    var attrImbrique = ligne.closest('.champs-multiple').attr('imbrique');
                    params.push({
                        action: ligneSansDonnee && sousBlocModifie ? 'delete' : paramsPreSauvegarde.type == 'POST' ? 'create' : paramsPreSauvegarde.type == 'PATCH' ? 'update' : 'delete',
                        id_instance: paramsPreSauvegarde.idModelInstance == 'None' ? '' : paramsPreSauvegarde.idModelInstance,
                        bloc_editable: paramsPreSauvegarde.blocEditable == 'True',
                        imbrique: attrImbrique != undefined ? attrImbrique.split(',') : '',
                        modifie: sousBlocModifie && !estExceptionSauvegarde,
                        erreur_fichier: estExceptionSauvegarde && erreurFichier != undefined ? erreurFichier : '',
                        nom_bloc: nomSousBloc,
                        id_bloc: idBloc,
                        no_ligne: ligne.attr('no-ligne'),
                        reactiver_ligne: ligne.attr('reactiver-ligne') != undefined,
                        id_document_ne_pas_creer: ligne.attr('id-document-ne-pas-creer') != undefined ? ligne.attr('id-document-ne-pas-creer') : null,
                        id_municipalite: $('#id_municipalite').val() || null
                    });

                    for (var property in blocDivision) {
                        if (blocDivision.hasOwnProperty(property)) {
                            params[params.length - 1][property] = blocDivision[property];
                        }
                    }

                    paramsSousBlocs[index] = params;
                }
            }
        }
    });

    return paramsSousBlocs;
}


function ligneEstSansDonnee(ligne) {
    if (ligne.hasClass('repere')) {
        return ligne.hasClass('repere-suppression');
    }

    var inputs = ligne.find(':input').not(':button').not('input[type=hidden]');
    if (ligne.is('.blocForm')) {
        inputs = inputs.not('.champs-multiple :input').not('.container-select-multiple-input-multiple select');
    }

    var nbCheckboxValeurZero = 0;
    // DM: changé le sélecteur pour les champs hidden car rien n'était pris en compte lorsque le bloc était collapsé
    var empty = inputs.filter(function () {
        // pour chaque input, on vérifie s'il y a une donnée
        if ($(this).is('input:checkbox')) {
            if ($(this).val() === '0') {
                nbCheckboxValeurZero += 1;
            }
            return $(this).val() === true || $(this).val() !== '';
        }

        // DM: exception avec NR bloc 31 colonne partie de la table de gauche
        if ($(this).attr('name') === 'partieParoiInterieure') return false;

        return $(this).val() !== '' && $(this).val() !== null;
    });

    // vérifier s'il y a des checkboxs avec une valeur 0 et que le reste de la ligne est vide et que cette ligne n'a
    // pas de id-model-instance, alors on considère que la ligne est vide
    if (ligne.attr('id-model-instance') === 'None' && empty.length === nbCheckboxValeurZero) return true;

    return empty.length === 0;
}


function getParamsLigneSousBloc(ligne, obligerValidation) {
    obligerValidation = typeof obligerValidation !== 'undefined' ? obligerValidation : false;
    var params = [];
    var ligneStatut = LIGNE_STATUT.none;

    var reperesContainer = ligne.closest('.container-reperes');
    if (reperesContainer.length > 0) {
        return getParamsLigneSousBlocRepere(reperesContainer, ligne);
    }

    // Cas d'une modification
    if (ligne.find('.' + CLASSE_VALEUR_MODIFIEE).length > 0 || obligerValidation) {
        ligneStatut = LIGNE_STATUT.update;
        // mettre les champs actifs temporairement pour faire le serialize(ex.: dans le cas des inputs liés à un sélecteur)
        var disabledInputs = ligne.find(':input:disabled').removeAttr('disabled');
        // ajouter les checkbox unchecked
        var checkboxUnchecked = ligne.find(':checkbox:not(:checked)').not('.ctrl-suppression');

        // On doit séparer les valeurs monétaires parce qu'il est possible que des sous-blocs aient des données monétaires à l'intérieur.
        var inputsMoney = ligne.find(':input:not(button)').filter('.money');
        if (inputsMoney.length > 0) {
            params = ligne.find(':input').not(inputsMoney).serializeArray();
            $.each(inputsMoney, function () {
                params.push({name: $(this).attr('name'), value: $(this).autoNumeric('get')});
            });
        } else {
            params = ligne.find(':input').serializeArray();
        }

        // ajouter les checkbox unchecked dans le serialize
        $.each(checkboxUnchecked, function (index, element) {
            var $element = $(element);
            // prendre la valeur pour le false s'il y a lieu
            var valueFalse = $element.attr('value_false');
            params.push({name: $element.attr('name'), value: valueFalse != undefined ? valueFalse : 0});
        });
        disabledInputs.attr('disabled', true);
    }

    // Cas d'une suppression de ligne
    if (ligne.find('.' + CLASSE_SUPPRESSION_LIGNE).length > 0) ligneStatut = LIGNE_STATUT.delete;

    // DM: ne pas envoyer au serveur une ligne supprimée sans ID (donc pas dans la BD)
    if (ligne.find('.' + CLASSE_SUPPRESSION_LIGNE_SAUVEGARDEE).length > 0) {
        params = [];
        ligneStatut = LIGNE_STATUT.none;
    }

    return {'params': params, 'ligneStatut': ligneStatut};
}

// chargementInitial: vrai si on appelle cette fonction au chargement de l'interface. Juste pour ne pas tout vider la section Prix de vente, si "prix sans taxes" est NULL
function calculerPrixVenteRajuste(chargementInitial) {
    chargementInitial = (typeof chargementInitial !== 'undefined') ? chargementInitial : false;
    var accordionPrixVente = $('#accordion-prix-vente');

    var prixDeclareSansTaxes = accordionPrixVente.find('[name="prix_declare_sans_taxes"]');
    var prixDeclareAvecTaxes = accordionPrixVente.find('[name="prix_declare"]');

    if (chargementInitial && !prixDeclareSansTaxes.val()) {
        return;
    }

    calculerPrixAvecTaxes(prixDeclareSansTaxes, prixDeclareAvecTaxes);

    var valeursBiens = $('input[name="montant_bien_non_immobilier"]');
    calculerMontant($('#bien-non-immobilier-mutation').find('[name="valeur"]'), valeursBiens, true);

    var rajustements = $('input[name="montant_rajustement"]');
    calculerMontant($('#rajustement-mutation').find('[name="valeur"]'), rajustements);

    var prixRajuste = parseFloat(prixDeclareAvecTaxes.autoNumeric('get')) + parseFloat(valeursBiens.autoNumeric('get')) + parseFloat(rajustements.autoNumeric('get'));
    setValeurInputMoney(accordionPrixVente.find('[name="prix_rajuste"]'), prixRajuste);

    // si le prix de vente sans taxes n'a pas été saisi, on ne voit pas des zéros dans les champs calculés qui sont à 0
    if (prixDeclareSansTaxes.autoNumeric('get') == '') {
        accordionPrixVente.find('input.money').each(function () {
            if ($(this).autoNumeric('get') == 0) {
                $(this).val('');
            }
        });
    }
}

function calculerMontant(inputValeur, inputCalcul, forcerNegatif) {
    if (forcerNegatif === undefined) forcerNegatif = false;
    var montant = 0.00;
    $.each(inputValeur, function () {
        montant = getValeurInputMoney($(this), montant);
    });
    if (forcerNegatif) {
        montant = -montant;
    }
    setValeurInputMoney(inputCalcul, montant);
}

function getValeurInputMoney(input, montant) {
    if (typeof montant === 'undefined') montant = 0.00;

    var valeur = 0.00;
    // si la valeur n'est pas dans une ligne en suppression, on prend cette valeur
    if (!input.is('.suppression-ligne input')) {
        valeur = input.autoNumeric('get');
    }
    montant += valeur != '' ? parseFloat(valeur) : 0.00;
    return montant;
}

function setValeurInputMoney(inputCalcul, calcul) {
    inputCalcul.attr('value', calcul);
    inputCalcul.autoNumeric('set', inputCalcul.attr('value'));
}

function calculerPrixAvecTaxes(prixDeclareSansTaxes, inputCalcul) {
    var accordionPrixVente = $('#accordion-prix-vente');

    var prixSansTaxes = getValeurInputMoney(prixDeclareSansTaxes);
    var tvq = getValeurInputMoney(accordionPrixVente.find('[name="tvq"]'));
    var tps = getValeurInputMoney(accordionPrixVente.find('[name="tps"]'));
    var ristourneTvq = getValeurInputMoney(accordionPrixVente.find('[name="ristourne_tvq"]'));
    var ristourneTps = getValeurInputMoney(accordionPrixVente.find('[name="ristourne_tps"]'));

    var prixAvecTaxes = prixSansTaxes + tvq + tps - ristourneTvq - ristourneTps;
    setValeurInputMoney(inputCalcul, prixAvecTaxes);
}

function cacherReperesSurSuppression(containerLignes) {
    // s'il y a un QC sur une ligne en suppression, il faut cacher les repères associés à ce QC
    var lignes = containerLignes.find('.sous-bloc-form');
    $.each(lignes, function (index, ligne) {
        var $ligne = $(ligne);
        var qcComposante = $ligne.find('.qc [name$=composante]').val();
        if (qcComposante != undefined) {
            var noLigne = $ligne.attr('no-ligne');
            var accordionComposante = $('#reperes').find('[name="accordion-qc-composante-' + qcComposante + '"][no-ligne="' + noLigne + '"]');
            var reperesParQc = accordionComposante.find('.repere');
            if ($ligne.find('.' + CLASSE_SUPPRESSION_LIGNE).length != 0) {
                reperesParQc.addClass('repere-suppression');
                accordionComposante.addClass('display-none');
            }
            else if (reperesParQc.hasClass('repere-suppression')) {
                reperesParQc.removeClass('repere-suppression');
                accordionComposante.removeClass('display-none');
            }
        }
    });
}

function forcerUpdateDocument(ligne) {
    // Quand c'est un document du bloc 05, 06 ou 90
    var nomSousBloc = ligne.closest('.champs-multiple').attr('id');
    var listeNomSousBloc = ['b05-document', 'b06-document', 'b90-document'];
    if (listeNomSousBloc.filter(option => nomSousBloc.startsWith(option)).length) {

        // Quand c'est une ligne ayant été supprimée et on veut la réactiver, alors on veut updater la date_fin i.e.
        // pas de create
        if (ligne.attr('reactiver-ligne') != undefined &&
            ligne.find('.ace-file-input .ace-file-container.selected').length == 0) {
            return true;
        }

        // Quand les champs avec historicité ne sont pas modifiés, alors on veut seulement updater la ligne de document
        // et ne pas dupliquer la ligne avec historicité i.e. pas de create
        var champsModifies = ligne.find('.form-control.' + CLASSE_VALEUR_MODIFIEE);
        var champsHistoriqueModifies = champsModifies.filter(function() {
            // on garde le champ s'il est modifié
            if ($(this).attr('name') === 'document.nom') {
                return true;
            }

            var listeNomSousBloc = ['b05-document', 'b06-document'];
            if (listeNomSousBloc.filter(option => nomSousBloc.startsWith(option)).length &&
                $(this).attr('name') === 'bool_principale') {
                ligne.attr('id-document-ne-pas-creer', ligne.find('[name="document.id_document"]').val());
                return true;
            }
            return false;
        });
        if (champsModifies.length > 0 && champsHistoriqueModifies.length == 0) {
            return true;
        }
    }
    return false;
}
